import { FC, Fragment, useContext, ReactElement } from 'react';
import { history, IRouteComponentProps } from 'umi';
import Context from '@/utils/context';
import { Row, Col } from 'antd';
import { Form, message } from 'iglooform';
import { useIntl } from 'react-intl';
import throttle from 'lodash/throttle';
import { BackButton } from '@/components/back-button/back-button';
import { HeaderTitle } from '@/components/header-title/header-title';
import { resetPaymentPassword } from '../../service';
import './index.less';
import { payNumberReg } from '@/utils/regexp';

const ForgetPasswordPage: FC<IRouteComponentProps> = ({
  location,
}: IRouteComponentProps): ReactElement => {
  const form = Form.useForm();
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);

  const handleSetPaymentPassword = throttle(
    async (value: any): Promise<void> => {
      try {
        resetPaymentPassword({
          otp_code: location.query.otp_code,
          otp_type: location.query.otp_type,
          payment_password: value.pinNumber,
        }).then((res: any) => {
          if (res) {
            message.success(
              formatMessage({
                id: 'Reset payment password successfully!',
              }),
            );
            history.push('/home');
          }
        });
      } catch (error) {
        console.error('Reset payment password error: ', error);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      <Row style={isPc ? { marginTop: '40px' } : { marginTop: '24px' }}>
        <Col
          span={isPc ? 12 : 24}
          style={{ maxWidth: '538px', margin: '0 auto' }}
        >
          <HeaderTitle
            title={formatMessage({ id: 'Set Payment Password' })}
            subTitle={formatMessage({
              id: 'Create a payment password for critical transactions.',
            })}
          />
          <div className="form-container">
            <Form
              form={form}
              config={{
                type: 'Login',
                elements: [
                  {
                    type: 'Password',
                    label: formatMessage({
                      id: 'Payment Password',
                      defaultMessage: 'Payment Password',
                    }),
                    name: 'pinNumber',
                    fullRow: true,
                    required: true,
                    initialValue: '',
                    help: formatMessage({
                      id: '6 digital number',
                      defaultMessage: '6 digital number',
                    }),
                    rules: [
                      {
                        validator: (rule: any, value: string) => {
                          const p = form.getFieldValue('confirmPinNumber');
                          if (!!value && !payNumberReg.test(value?.trim())) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'Payment password must 6 length!',
                                }),
                              ),
                            );
                          } else if (!!p && p !== value) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'The two payment password is inconsistent!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                    antdDependencies: ['confirmPinNumber'],
                  },
                  {
                    type: 'Password',
                    label: formatMessage({
                      id: 'Confirm Payment Password',
                      defaultMessage: 'Confirm Payment Password',
                    }),
                    name: 'confirmPinNumber',
                    fullRow: true,
                    required: true,
                    initialValue: '',
                    rules: [
                      {
                        validator: (rule: any, value: string) => {
                          const p = form.getFieldValue('pinNumber');
                          if (!!value && p !== value) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'The two payment password is inconsistent!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                    antdDependencies: ['pinNumber'],
                  },
                ],
              }}
              onSubmit={handleSetPaymentPassword}
              locales={{
                submitText: formatMessage({
                  id: 'Done',
                  defaultMessage: 'Done',
                }),
                validateMessages: {
                  required:
                    '${label} ' +
                    formatMessage({
                      id: 'is required',
                    }),
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ForgetPasswordPage;
